export default __webpack_public_path__ + "static/media/step_I@2x.e0be29d1.png";